import classNames from 'classnames'
import i18next from 'i18next'
import * as React from 'react'
import { SVG_Cross } from '../svg/SVG_Cross'
import { SVG_Tick } from '../svg/SVG_Tick'

interface Props {
    onClick: () => void
    markedAsComplete: boolean
}

export function MarkAsCompleteButton(props: Props) {
    const iconSizeProps = { height: '20', width: '20' }

    return (
        <button
            className={classNames('AppCore__guide__MarkAsCompleteButton', {
                'AppCore__guide__MarkAsCompleteButton-unmark': props.markedAsComplete,
            })}
            onClick={props.onClick}
        >
            {props.markedAsComplete ? (
                <SVG_Cross {...iconSizeProps} />
            ) : (
                <SVG_Tick color="var(--white)" {...iconSizeProps} />
            )}
            {props.markedAsComplete
                ? i18next.t('appcore:ElementGuide.unmarkAsComplete')
                : i18next.t('appcore:ElementGuide.markAsComplete')}
        </button>
    )
}
